// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2MUSL","header":"MergedInvoice_header__14nre"};